import React from 'react'

import { Box, Table, Text } from '@superlogica/design-system'
import { BoxTabTable, BoxTitleTable } from 'styles/global-style'

const View = ({ isLoading, isError, faturasRebate = [], columns, refetch }) => {
  console.log(faturasRebate)
  return faturasRebate.length > 0 ? (
    <>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xxs"
        radius="md"
        className="flex align-center"
      >
        <BoxTitleTable paddingSize="none">
          <Text className="mr-xxxs">Faturas</Text>
          <Text color="neutral400" size="body02">
            {`${faturasRebate.length} itens`}
          </Text>
        </BoxTitleTable>
      </BoxTabTable>
      <Box border borderColor="neutral300" bgColor="neutral0" paddingSize="none" radius="xs">
        <Table
          data={faturasRebate}
          columns={columns}
          tableName="faturas"
          refetch={refetch}
          isError={isError}
          isLoading={isLoading}
        />
      </Box>
    </>
  ) : (
    <Box
      border
      borderColor="neutral300"
      bgColor="neutral0"
      paddingType="squish"
      paddingSize="md"
      radius="xs"
    >
      <Text>{''}</Text>
    </Box>
  )
}

export default View
